/**
 * Format a date as ISO `YYYY-MM-DD`.
 * Accepts an ISO string (returned as-is after validation) or a `Date`.
 * Returns an em dash for null / unparseable input.
 */
export function formatDate(value: string | Date | null | undefined): string {
  if (value == null) return "—";
  if (value instanceof Date) {
    if (Number.isNaN(value.getTime())) return "—";
    const y = value.getFullYear();
    const m = String(value.getMonth() + 1).padStart(2, "0");
    const d = String(value.getDate()).padStart(2, "0");
    return `${y}-${m}-${d}`;
  }
  if (!/^\d{4}-\d{2}-\d{2}/.test(value)) return value || "—";
  return value.slice(0, 10);
}

/**
 * Format a 0–1 score as a two-decimal string, e.g. `0.99`.
 */
export function formatScore(score: number): string {
  return score.toFixed(2);
}

/**
 * Format a 0–100 percent as `12%` (integer) or `12.3%` (decimal).
 */
export function formatPercent(value: number): string {
  if (Number.isInteger(value)) return `${value}%`;
  return `${value.toFixed(1)}%`;
}

/**
 * Format an integer with US-style thousands separators, e.g. `10,000`.
 * Locale is pinned to "en-US" so the output doesn't vary with the browser's locale.
 */
export function formatNumber(value: number): string {
  return value.toLocaleString("en-US");
}
